<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group">
          <label class="col-sm-2 control-label">{{ $t("message.Import QR course") }}</label>
          <div class="col-sm-3">
            <div>
              <input
                class=""
                type="file"
                ref="file"
                accept="xls/*"
                @change="handleFileUpload()"
              />
            </div>
          </div>
          <div class="col-sm-2">
            <div class="btn btn-primary" @click="downloadTemplate()">
              {{ $t("message.download") }}
            </div>
          </div>
        </div>
        <div class="form-group" v-if="lastTemplate">
          <label class="col-sm-2 control-label">
            {{$t("message.lastFile") }}
          </label>
          <div class="col-sm-3">
            <div style="margin-top: 7px">
              <a :href="lastTemplate" target="_blank">{{fileName}}</a>
            </div>
          </div>
        </div>
        <div class="form-group" v-if="uploadTime">
          <label class="col-sm-2 control-label">
            {{$t("message.last update time") }}
          </label>
          <div class="col-sm-3">
            <div style="margin-top: 7px">
              {{ uploadTime }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";
import axios from "axios"

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  data() {
    return {
      page: 1,
      template:"",
      lastTemplate:"",
      fileName: "",
      uploadTime: "",
    };
  },
  created: function() {

    this.exportEvent();
  },
  methods: {
    async handleFileUpload() {
      this.file = this.$refs.file.files[0];
      
      let formData = new FormData();

      /*
                Add the form data we need to submit
            */
      formData.append("file", this.file);
      formData.append('session', this.$store.state.userInfo.session);
      formData.append('userId', this.$store.state.userInfo.systemUserId);
      formData.append('lang', "en_US")
      /*
          Make the request to the POST /single-file URL
        */
      axios
        .post(this.domain+'/importQrCourse', formData)
        .then(data => {
          if (data.data.errorCode === 0) {
            this.$toastr.s("Import success");
            this.exportEvent();
          }else{
            var that = this;
            this.$store.commit("setwarning", {
                string: data.data.errorMessage,
                boolean: true,
                button: [{
                  name:this.$i18n.t("message.Cancel"),
                  callBack:function(){
                    that.$store.commit("setwarning", {
                      string: "",
                      boolean: false,
                    });
                  }
                }]
            })
          }
          this.$refs.file.value = "";
        })
        .catch((e) => {
          this.$toastr.w("Time out, you can check status later","Warning");
          this.$refs.file.value = "";
        });
    },
    async exportEvent() {
      var that = this;
      let obj = this.getAuthObj;
      let data = await this.$store.dispatch("exportQrCourse", this.setFormData(obj));

      if(data.data.result){
        this.template = data.data.result.templatePath;
        this.lastTemplate = data.data.result.filePath;
        this.fileName = data.data.result.fileName;
        this.uploadTime = data.data.result.uploadTime;
      }
    },
    downloadTemplate(){
      window.open(this.template )
    }
  },
  mounted() {
  },
};
</script>